const self = {}

function inheritError (fn, name) {
  // eslint-disable-next-line no-param-reassign
  fn.prototype = Object.create(Error.prototype, {
    name: {
      value: name,
      enumerable: false,
      configurable: false,
      writable: false,
    },
  })
}

const setAttrib = function (obj, name, opts) {
  const valueToApply = typeof opts === 'object' ? opts[name] : opts
  if (valueToApply != null) {
    // eslint-disable-next-line no-param-reassign
    obj[name] = valueToApply
  }
}

function AccountExists (opts) {
  setAttrib(this, 'account', opts)
  this.message = `An account with email ${this.account} already exists`
}
inheritError(AccountExists, 'AccountExists')
self.AccountExists = AccountExists

function AccountMissing (opts) {
  setAttrib(this, 'account', opts)
  this.message = `An account with email ${this.account} does not exist`
}
inheritError(AccountMissing, 'AccountMissing')
self.AccountMissing = AccountMissing

function IncorrectPassword () {
  this.message = 'The supplied password was incorrect'
}
inheritError(IncorrectPassword, 'IncorrectPassword')
self.IncorrectPassword = IncorrectPassword

function NullInput (opts) {
  setAttrib(this, 'functionName', opts)
  this.message = `Input to ${this.functionName} cannot be null`
}
inheritError(NullInput, 'NullInput')
self.NullInput = NullInput

function NonExisting (opts) {
  setAttrib(this, 'type', opts)
  setAttrib(this, 'id', opts)
  this.message = `No ${this.type} with id ${this.id} was found`
}
inheritError(NonExisting, 'NonExisting')
self.NonExisting = NonExisting

function NonExistingEntities (opts) {
  setAttrib(this, 'type', opts)
  setAttrib(this, 'unknownIds', opts)
  this.message = `No entities of type ${this.type} with id:s ${this.unknownIds.join(', ')} were found`
}
inheritError(NonExistingEntities, 'NonExistingEntities')
self.NonExistingEntities = NonExistingEntities

function NonExistingForEntity (opts) {
  setAttrib(this, 'type', opts)
  setAttrib(this, 'parentType', opts)
  setAttrib(this, 'id', opts)
  this.message = `No ${this.type} for ${this.parentType} with id ${this.id} was found`
}
inheritError(NonExistingForEntity, 'NonExistingForEntity')
self.NonExistingForEntity = NonExistingForEntity

function NotAuthorized (opts) {
  setAttrib(this, 'reason', opts)
  this.message = `Not authorized: ${this.reason}`
}
inheritError(NotAuthorized, 'NotAuthorized')
self.NotAuthorized = NotAuthorized

function Forbidden (opts) {
  setAttrib(this, 'type', opts)
  setAttrib(this, 'reason', opts)
  this.message = `Access denied: ${this.reason}`
}
inheritError(Forbidden, 'Forbidden')
self.Forbidden = Forbidden

function NotLoggedIn () {
  this.message = 'You have been logged out. You will need to log in again to perform this action.'
}
inheritError(NotLoggedIn, 'NotLoggedIn')
self.NotLoggedIn = NotLoggedIn

function NoAuthorizerExists (opts) {
  if (opts instanceof Array) {
    this.unknownKeys = opts
  } else {
    this.unknownKeys = opts.unknownKeys
  }
  const unknownKeys = this.unknownKeys || []
  this.message = `No authorizer exists for keys ${unknownKeys.join(', ')}`
}
inheritError(NoAuthorizerExists, 'NoAuthorizerExists')
self.NoAuthorizerExists = NoAuthorizerExists

function NoReadModelExists (opts) {
  setAttrib(this, 'readModel', opts)
  this.message = `No readModel exist with name ${this.readModel}`
}
inheritError(NoReadModelExists, 'NoReadModelExists')
self.NoReadModelExists = NoReadModelExists

function NoReadModelMethodExists (opts) {
  setAttrib(this, 'readModel', opts)
  setAttrib(this, 'method', opts)
  this.message = [ 'Read model', this.readModel, 'has no method', this.method ].join(' ')
}
inheritError(NoReadModelMethodExists, 'NoReadModelMethodExists')
self.NoReadModelMethodExists = NoReadModelMethodExists

function NoValidatorExists (opts) {
  setAttrib(this, 'entity', opts)
  this.message = `No validator exist for key ${this.entity}`
}
inheritError(NoValidatorExists, 'NoValidatorExists')
self.NoValidatorExists = NoValidatorExists

function ValidationError (opts) {
  const name = (opts && opts.name) ? opts.name : 'unknown command'
  setAttrib(this, 'errors', opts)
  setAttrib(this, 'params', opts)
  this.message = `Input validation error for command ${name}`
}
inheritError(ValidationError, 'ValidationError')
self.ValidationError = ValidationError

function InputValidationError (opts) {
  setAttrib(this, 'message', opts || 'Input validation error')
}
inheritError(InputValidationError, 'InputValidationError')
self.InputValidationError = InputValidationError

function PaymentAuthenticationError () {
  this.message = 'Failed to authenticate, please check supplied authentication details'
}
inheritError(PaymentAuthenticationError, 'PaymentAuthenticationError')
self.PaymentAuthenticationError = PaymentAuthenticationError

function PaymentAuthorizationError () {
  this.message = 'Permission denied, you are not authorized to perform this action'
}
inheritError(PaymentAuthorizationError, 'PaymentAuthorizationError')
self.PaymentAuthorizationError = PaymentAuthorizationError

function PaymentDownForMaintenance () {
  this.message = 'Payment services are currently unavailable due to maintenance'
}
inheritError(PaymentDownForMaintenance, 'PaymentDownForMaintenance')
self.PaymentDownForMaintenance = PaymentDownForMaintenance

function PaymentEntityNotFoundError () {
  this.message = 'Invalid payment entity ID'
}
inheritError(PaymentEntityNotFoundError, 'PaymentEntityNotFoundError')
self.PaymentEntityNotFoundError = PaymentEntityNotFoundError

function PaymentServiceError (opts) {
  setAttrib(this, 'message', opts || 'An unexpected payment service error has occurred')
}
inheritError(PaymentServiceError, 'PaymentServiceError')
self.PaymentServiceError = PaymentServiceError

function PaymentValidationError (opts) {
  setAttrib(this, 'errors', opts)
  setAttrib(this, 'message', opts)
  setAttrib(this, 'params', opts)
}
inheritError(PaymentValidationError, 'PaymentValidationError')
self.PaymentValidationError = PaymentValidationError

function PaymentError (opts) {
  setAttrib(this, 'message', opts)
}
inheritError(PaymentError, 'PaymentError')
self.PaymentError = PaymentError

function MailError (opts) {
  setAttrib(this, 'message', opts || 'An unexpected email service error has occurred')
}
inheritError(MailError, 'MailError')
self.MailError = MailError

function NoActiveSubscriptionExists (opts) {
  setAttrib(this, 'organizationId', opts)
  this.message = 'Your subscription is not valid, activate your account to make changes.'
}
inheritError(NoActiveSubscriptionExists, 'NoActiveSubscriptionExists')
self.NoActiveSubscriptionExists = NoActiveSubscriptionExists

function PayingSubscriptionAlreadyExists (opts) {
  setAttrib(this, 'ownerId', opts)
  this.message = 'A paying subscription already exists'
}
inheritError(PayingSubscriptionAlreadyExists, 'PayingSubscriptionAlreadyExists')
self.PayingSubscriptionAlreadyExists = PayingSubscriptionAlreadyExists

function UserLimitExceeded () {
  this.message = 'User limit exceeded, please upgrade to a suitable subscription plan'
}
inheritError(UserLimitExceeded, 'UserLimitExceeded')
self.UserLimitExceeded = UserLimitExceeded

function ActiveUser (opts) {
  setAttrib(this, 'userId', opts)
  this.message = `User with id ${this.userId} is active`
}
inheritError(ActiveUser, 'ActiveUser')
self.ActiveUser = ActiveUser

function NameExists (opts) {
  setAttrib(this, 'existingName', opts)
  setAttrib(this, 'type', opts)
  this.message = `A ${this.type} with name ${this.existingName} already exists`
}
inheritError(NameExists, 'NameExists')
self.NameExists = NameExists

function NonExistingProp (opts) {
  setAttrib(this, 'propName', opts)
  this.message = `Property ${this.propName} does not exist`
}
inheritError(NonExistingProp, 'NonExistingProp')
self.NonExistingProp = NonExistingProp

function NotOrganizationMember (opts) {
  setAttrib(this, 'userId', opts)
  setAttrib(this, 'organizationId', opts)
  this.message = `User with id ${this.userId} is not a member of org ${this.organizationId}`
}
inheritError(NotOrganizationMember, 'NotOrganizationMember')
self.NotOrganizationMember = NotOrganizationMember

function NoIntegrityCheckExists (opts) {
  if (opts instanceof Array) {
    this.unknownKeys = opts
  } else {
    this.unknownKeys = opts.unknownKeys
  }
  const unknownKeys = this.unknownKeys || []
  this.message = `No integrity check exists for keys ${unknownKeys.join(', ')}`
}
inheritError(NoIntegrityCheckExists, 'NoIntegrityCheckExists')
self.NoIntegrityCheckExists = NoIntegrityCheckExists

function DataIntegrityCheckFailed (opts) {
  const defaultMessage = 'Data integrity check failed'
  const optsToUse = typeof opts === 'object'
    ? ({ message: defaultMessage, ...opts })
    : { message: (opts || defaultMessage) }
  setAttrib(this, 'message', optsToUse)
  setAttrib(this, 'meta', optsToUse)
}
inheritError(DataIntegrityCheckFailed, 'DataIntegrityCheckFailed')
self.DataIntegrityCheckFailed = DataIntegrityCheckFailed

function NameNotAllowed (opts) {
  setAttrib(this, 'notAllowedName', opts)
  this.message = `The name ${this.notAllowedName} is not allowed`
}
inheritError(NameNotAllowed, 'NameNotAllowed')
self.NameNotAllowed = NameNotAllowed

function QueryValidationError (opts) {
  setAttrib(this, 'reason', opts)
  setAttrib(this, 'query', opts)
  this.message = `QueryValidationError: ${this.reason}`
}
inheritError(QueryValidationError, 'QueryValidationError')
self.QueryValidationError = QueryValidationError

function ServerError (opts) {
  setAttrib(this, 'message', opts || 'Internal server error')
}
inheritError(ServerError, 'ServerError')
self.ServerError = ServerError

function EntityExpiredError (opts) {
  setAttrib(this, 'type', opts)
  setAttrib(this, 'id', opts)
  this.message = `${this.type} with id ${this.id} has expired`
}
inheritError(EntityExpiredError, 'EntityExpiredError')
self.EntityExpiredError = EntityExpiredError

function EntityAlreadyExists (opts) {
  setAttrib(this, 'type', opts)
  setAttrib(this, 'reason', opts)
  this.message = `${this.type} already exists: ${this.reason}`
}
inheritError(EntityAlreadyExists, 'EntityAlreadyExists')
self.EntityAlreadyExists = EntityAlreadyExists

module.exports = self
